import React from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import PersonIcon from '@mui/icons-material/Person';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import StorageIcon from '@mui/icons-material/Storage';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { wsBaseUrl } from '../services/apiConfig';

export const Login = ({ username, setUsername, password, setPassword }) => {
    const Navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleLogin();
        }
    };

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${wsBaseUrl}login.php`, {
                username: username,
                password: password,
            });

            if (response.data.success) {
                const tokenExpiryDate = new Date();
                tokenExpiryDate.setTime(tokenExpiryDate.getTime() + (12 * 60 * 60 * 1000));
                document.cookie = `PHPSESSID=${response.data.token}; path=/; expires=${tokenExpiryDate.toUTCString()};`;

                localStorage.setItem('username', response.data.nombre);
                localStorage.setItem('mail', response.data.mail);
                localStorage.setItem('DesRepresentante', response.data.nombre);
                setPassword('');
                setUsername('');

                Swal.fire({
                    icon: "success",
                    title: `Bienvenido/a \n${username}`,
                    showConfirmButton: false,
                    timer: 1000,
                    background: "#303031",
                    color: "#f2f0f0",
                });
                Navigate('/');
            } else {
                Swal.fire({
                    icon: "error",
                    title: `Error de inicio de sesion: \n${response.data.message}`,
                    showConfirmButton: false,
                    timer: 1500,
                    background: "#303031",
                    color: "#f2f0f0",
                });
            }
        } catch (error) {
            console.error('Error de red:', error.message);
        }
    };

    return (
        <Grid
            container
            direction="column"
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                minHeight: '90vh',
                px: { xs: 2, md: 6 },
                py: { xs: 4, md: 6 },
                background: 'linear-gradient(180deg, #faf9f9 0%, #efeded 100%)',
            }}
            className='load'
        >
            <Grid
                container
                spacing={3}
                sx={{
                    justifyContent: 'center',
                    alignItems: 'stretch',
                    width: '100%',
                    maxWidth: 980,
                }}
            >
                <Grid item size={{ xs: 12, md: 5 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            height: '100%',
                            minHeight: { xs: 180, md: 420 },
                            p: { xs: 3, md: 4 },
                            borderRadius: 4,
                            border: '1px solid #e0bfbb',
                            borderTop: '4px solid #710008',
                            backgroundColor: '#710008',
                            color: '#ffffff',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            textAlign: 'left',
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 2,
                                    backgroundColor: 'rgba(255, 255, 255, 0.12)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 3,
                                }}
                            >
                                <StorageIcon />
                            </Box>

                            <Typography variant="caption" sx={{ color: '#ffb4ac' }}>
                                Panel tecnico
                            </Typography>
                            <Typography variant="h1" sx={{ mt: 1, fontSize: { xs: 28, md: 36 } }}>
                                Control de copias
                            </Typography>
                        </Box>

                        <Grid container spacing={1.5} sx={{ mt: 4 }}>
                            <Grid item size={{ xs: 12 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        color: '#ffdad6',
                                    }}
                                >
                                    <ShieldOutlinedIcon fontSize="small" />
                                    <Typography variant="caption" sx={{ color: '#ffdad6' }}>
                                        Acceso privado
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item size={{ xs: 12, md: 7 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: { xs: 3, sm: 4, md: 5 },
                            borderRadius: 4,
                            border: '1px solid #e0bfbb',
                            borderTop: '4px solid #710008',
                            backgroundColor: '#ffffff',
                            boxShadow: '0 8px 24px rgba(113, 0, 8, 0.10)',
                            textAlign: 'left',
                        }}
                    >
                        <Typography variant="caption" color="text.secondary">
                            Identificacion
                        </Typography>
                        <Typography variant="h4" sx={{ mt: 1, mb: 4, color: '#1b1c1c' }}>
                            Iniciar sesion
                        </Typography>

                        <Grid
                            container
                            direction="column"
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'stretch',
                            }}
                            spacing={3}
                        >
                            <Grid item size={{ xs: 12 }}>
                                <FormControl fullWidth variant="outlined" color='primary'>
                                    <InputLabel htmlFor="login-username">Correo electronico</InputLabel>
                                    <OutlinedInput
                                        id="login-username"
                                        color='primary'
                                        name='username'
                                        type='text'
                                        value={username}
                                        placeholder='Correo electronico'
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <PersonIcon color="gris" />
                                            </InputAdornment>
                                        }
                                        label="Correo electronico"
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item size={{ xs: 12 }}>
                                <FormControl fullWidth variant="outlined" color='primary' onKeyDown={handleKeyPress}>
                                    <InputLabel htmlFor="login-password">Contrasena</InputLabel>
                                    <OutlinedInput
                                        id="login-password"
                                        color='primary'
                                        name='password'
                                        value={password}
                                        placeholder='Contrasena'
                                        type={showPassword ? 'text' : 'password'}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <VpnKeyIcon color="gris" />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Mostrar u ocultar contrasena"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOffIcon color='gris' /> : <VisibilityIcon color='gris' />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="Contrasena"
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item size={{ xs: 12 }}>
                                <Button
                                    variant="contained"
                                    color='secondary'
                                    size="large"
                                    fullWidth
                                    onClick={() => handleLogin()}
                                >
                                    Iniciar sesion
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    )
}
